import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { NgTemplateOutlet } from '@angular/common';
import { AppType } from '@vendasta/marketplace-apps';
import { FormatAppTypePipe } from './format-app-type.pipe';
import { ActivationStatus } from '@vendasta/sales-orders';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MenuItemClickedInterface, MenuItemInterface } from '../fulfillment-status.service';
import { FulfillmentOrderStatus } from '@vendasta/order-fulfillment';
import { statusColorMap, WorkOrderPersona } from '@vendasta/work-order';
import { GetFulfillmentBadgeDataPipe } from './get-fulfillment-badge-data.pipe';
@Component({
  selector: 'orders-fulfillment-row',
  templateUrl: './fulfillment-row.component.html',
  styleUrls: ['./fulfillment-row.component.scss'],
  providers: [],
  imports: [
    GalaxyAvatarModule,
    FormatAppTypePipe,
    GalaxyBadgeModule,
    GalaxyPopoverModule,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    TranslateModule,
    NgTemplateOutlet,
    MatMenuTrigger,
    GetFulfillmentBadgeDataPipe,
  ],
})
export class FulfillmentRowComponent {
  @Input() name: string;
  @Input() iconUrl: string;
  @Input() type: AppType;
  @Input() parentName: string;
  @Input() activationStatus: ActivationStatus;
  @Input() activationErrorDetails: string;
  @Input() menuItems: MenuItemInterface[] = [];
  @Input() fulfillmentStatus: FulfillmentOrderStatus = 0;
  @Input() persona: WorkOrderPersona;
  @Output() menuItemClicked: EventEmitter<MenuItemClickedInterface> = new EventEmitter<MenuItemClickedInterface>();
  @Output() workOrdersLinkClicked: EventEmitter<void> = new EventEmitter<void>();

  public ActivationStatus = ActivationStatus;
  protected readonly badgeColors = statusColorMap.get(WorkOrderPersona.SALES);

  menuItemClick(item: MenuItemInterface): void {
    this.menuItemClicked.emit({ value: item.value, eventType: item.eventType });
  }

  handleWorkOrdersLinkClicked(): void {
    this.workOrdersLinkClicked.emit();
  }

  protected readonly FulfillmentOrderStatus = FulfillmentOrderStatus;
}
